import { JSX } from 'react'

import HomeIcon from '../../assets/logo/Home.svg'

const HomeCustomIcon = (): JSX.Element => <img src={HomeIcon} alt="logo" />

export default HomeCustomIcon
